// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file revit_service.proto (package pipeex.revit.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file revit_service.proto.
 */
export const file_revit_service: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message pipeex.revit.v1.PingRequest
 */
export type PingRequest = Message<"pipeex.revit.v1.PingRequest"> & {
};

/**
 * Describes the message pipeex.revit.v1.PingRequest.
 * Use `create(PingRequestSchema)` to create a new message.
 */
export const PingRequestSchema: GenMessage<PingRequest> = /*@__PURE__*/
  messageDesc(file_revit_service, 0);

/**
 * @generated from message pipeex.revit.v1.PingResponse
 */
export type PingResponse = Message<"pipeex.revit.v1.PingResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message pipeex.revit.v1.PingResponse.
 * Use `create(PingResponseSchema)` to create a new message.
 */
export const PingResponseSchema: GenMessage<PingResponse> = /*@__PURE__*/
  messageDesc(file_revit_service, 1);

/**
 * @generated from message pipeex.revit.v1.ConnectRequest
 */
export type ConnectRequest = Message<"pipeex.revit.v1.ConnectRequest"> & {
};

/**
 * Describes the message pipeex.revit.v1.ConnectRequest.
 * Use `create(ConnectRequestSchema)` to create a new message.
 */
export const ConnectRequestSchema: GenMessage<ConnectRequest> = /*@__PURE__*/
  messageDesc(file_revit_service, 2);

/**
 * @generated from message pipeex.revit.v1.ConnectResponse
 */
export type ConnectResponse = Message<"pipeex.revit.v1.ConnectResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: string fingerprint = 3;
   */
  fingerprint: string;
};

/**
 * Describes the message pipeex.revit.v1.ConnectResponse.
 * Use `create(ConnectResponseSchema)` to create a new message.
 */
export const ConnectResponseSchema: GenMessage<ConnectResponse> = /*@__PURE__*/
  messageDesc(file_revit_service, 3);

/**
 * @generated from message pipeex.revit.v1.SubscribeRequest
 */
export type SubscribeRequest = Message<"pipeex.revit.v1.SubscribeRequest"> & {
};

/**
 * Describes the message pipeex.revit.v1.SubscribeRequest.
 * Use `create(SubscribeRequestSchema)` to create a new message.
 */
export const SubscribeRequestSchema: GenMessage<SubscribeRequest> = /*@__PURE__*/
  messageDesc(file_revit_service, 4);

/**
 * @generated from message pipeex.revit.v1.RevitEvent
 */
export type RevitEvent = Message<"pipeex.revit.v1.RevitEvent"> & {
  /**
   * @generated from field: string event_type = 1;
   */
  eventType: string;

  /**
   * @generated from field: bytes payload = 2;
   */
  payload: Uint8Array;
};

/**
 * Describes the message pipeex.revit.v1.RevitEvent.
 * Use `create(RevitEventSchema)` to create a new message.
 */
export const RevitEventSchema: GenMessage<RevitEvent> = /*@__PURE__*/
  messageDesc(file_revit_service, 5);

/**
 * @generated from message pipeex.revit.v1.WriteLogRequest
 */
export type WriteLogRequest = Message<"pipeex.revit.v1.WriteLogRequest"> & {
  /**
   * @generated from field: repeated pipeex.revit.v1.LogEntry entries = 1;
   */
  entries: LogEntry[];
};

/**
 * Describes the message pipeex.revit.v1.WriteLogRequest.
 * Use `create(WriteLogRequestSchema)` to create a new message.
 */
export const WriteLogRequestSchema: GenMessage<WriteLogRequest> = /*@__PURE__*/
  messageDesc(file_revit_service, 6);

/**
 * @generated from message pipeex.revit.v1.LogEntry
 */
export type LogEntry = Message<"pipeex.revit.v1.LogEntry"> & {
  /**
   * @generated from field: string timestamp = 1;
   */
  timestamp: string;

  /**
   * @generated from field: string level = 2;
   */
  level: string;

  /**
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * @generated from field: string source = 4;
   */
  source: string;
};

/**
 * Describes the message pipeex.revit.v1.LogEntry.
 * Use `create(LogEntrySchema)` to create a new message.
 */
export const LogEntrySchema: GenMessage<LogEntry> = /*@__PURE__*/
  messageDesc(file_revit_service, 7);

/**
 * @generated from message pipeex.revit.v1.WriteLogResponse
 */
export type WriteLogResponse = Message<"pipeex.revit.v1.WriteLogResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message pipeex.revit.v1.WriteLogResponse.
 * Use `create(WriteLogResponseSchema)` to create a new message.
 */
export const WriteLogResponseSchema: GenMessage<WriteLogResponse> = /*@__PURE__*/
  messageDesc(file_revit_service, 8);

/**
 * @generated from message pipeex.revit.v1.BrowseFolderRequest
 */
export type BrowseFolderRequest = Message<"pipeex.revit.v1.BrowseFolderRequest"> & {
  /**
   * @generated from field: string initial_path = 1;
   */
  initialPath: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;
};

/**
 * Describes the message pipeex.revit.v1.BrowseFolderRequest.
 * Use `create(BrowseFolderRequestSchema)` to create a new message.
 */
export const BrowseFolderRequestSchema: GenMessage<BrowseFolderRequest> = /*@__PURE__*/
  messageDesc(file_revit_service, 9);

/**
 * @generated from message pipeex.revit.v1.BrowseFolderResponse
 */
export type BrowseFolderResponse = Message<"pipeex.revit.v1.BrowseFolderResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: string selected_path = 3;
   */
  selectedPath: string;

  /**
   * @generated from field: bool canceled = 4;
   */
  canceled: boolean;
};

/**
 * Describes the message pipeex.revit.v1.BrowseFolderResponse.
 * Use `create(BrowseFolderResponseSchema)` to create a new message.
 */
export const BrowseFolderResponseSchema: GenMessage<BrowseFolderResponse> = /*@__PURE__*/
  messageDesc(file_revit_service, 10);

/**
 * @generated from message pipeex.revit.v1.GetModelSetupStatusRequest
 */
export type GetModelSetupStatusRequest = Message<"pipeex.revit.v1.GetModelSetupStatusRequest"> & {
};

/**
 * Describes the message pipeex.revit.v1.GetModelSetupStatusRequest.
 * Use `create(GetModelSetupStatusRequestSchema)` to create a new message.
 */
export const GetModelSetupStatusRequestSchema: GenMessage<GetModelSetupStatusRequest> = /*@__PURE__*/
  messageDesc(file_revit_service, 11);

/**
 * @generated from message pipeex.revit.v1.GetModelSetupStatusResponse
 */
export type GetModelSetupStatusResponse = Message<"pipeex.revit.v1.GetModelSetupStatusResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: bool is_configured = 3;
   */
  isConfigured: boolean;

  /**
   * @generated from field: string configured_at = 4;
   */
  configuredAt: string;

  /**
   * @generated from field: string workflow = 5;
   */
  workflow: string;

  /**
   * @generated from field: repeated string parameter_names = 6;
   */
  parameterNames: string[];
};

/**
 * Describes the message pipeex.revit.v1.GetModelSetupStatusResponse.
 * Use `create(GetModelSetupStatusResponseSchema)` to create a new message.
 */
export const GetModelSetupStatusResponseSchema: GenMessage<GetModelSetupStatusResponse> = /*@__PURE__*/
  messageDesc(file_revit_service, 12);

/**
 * @generated from message pipeex.revit.v1.SaveModelSetupStatusRequest
 */
export type SaveModelSetupStatusRequest = Message<"pipeex.revit.v1.SaveModelSetupStatusRequest"> & {
  /**
   * @generated from field: string workflow = 1;
   */
  workflow: string;

  /**
   * @generated from field: repeated string parameter_names = 2;
   */
  parameterNames: string[];
};

/**
 * Describes the message pipeex.revit.v1.SaveModelSetupStatusRequest.
 * Use `create(SaveModelSetupStatusRequestSchema)` to create a new message.
 */
export const SaveModelSetupStatusRequestSchema: GenMessage<SaveModelSetupStatusRequest> = /*@__PURE__*/
  messageDesc(file_revit_service, 13);

/**
 * @generated from message pipeex.revit.v1.SaveModelSetupStatusResponse
 */
export type SaveModelSetupStatusResponse = Message<"pipeex.revit.v1.SaveModelSetupStatusResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message pipeex.revit.v1.SaveModelSetupStatusResponse.
 * Use `create(SaveModelSetupStatusResponseSchema)` to create a new message.
 */
export const SaveModelSetupStatusResponseSchema: GenMessage<SaveModelSetupStatusResponse> = /*@__PURE__*/
  messageDesc(file_revit_service, 14);

/**
 * @generated from message pipeex.revit.v1.SetPcfWindowVisibilityRequest
 */
export type SetPcfWindowVisibilityRequest = Message<"pipeex.revit.v1.SetPcfWindowVisibilityRequest"> & {
  /**
   * true = show the dockable pane, false = hide it.
   *
   * @generated from field: bool visible = 1;
   */
  visible: boolean;
};

/**
 * Describes the message pipeex.revit.v1.SetPcfWindowVisibilityRequest.
 * Use `create(SetPcfWindowVisibilityRequestSchema)` to create a new message.
 */
export const SetPcfWindowVisibilityRequestSchema: GenMessage<SetPcfWindowVisibilityRequest> = /*@__PURE__*/
  messageDesc(file_revit_service, 15);

/**
 * @generated from message pipeex.revit.v1.SetPcfWindowVisibilityResponse
 */
export type SetPcfWindowVisibilityResponse = Message<"pipeex.revit.v1.SetPcfWindowVisibilityResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message pipeex.revit.v1.SetPcfWindowVisibilityResponse.
 * Use `create(SetPcfWindowVisibilityResponseSchema)` to create a new message.
 */
export const SetPcfWindowVisibilityResponseSchema: GenMessage<SetPcfWindowVisibilityResponse> = /*@__PURE__*/
  messageDesc(file_revit_service, 16);

/**
 * @generated from message pipeex.revit.v1.StartOperationResponse
 */
export type StartOperationResponse = Message<"pipeex.revit.v1.StartOperationResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: string operation_id = 3;
   */
  operationId: string;
};

/**
 * Describes the message pipeex.revit.v1.StartOperationResponse.
 * Use `create(StartOperationResponseSchema)` to create a new message.
 */
export const StartOperationResponseSchema: GenMessage<StartOperationResponse> = /*@__PURE__*/
  messageDesc(file_revit_service, 17);

/**
 * Per-parameter data type hint using shared parameter file DATA tokens
 * (TEXT, INTEGER, NUMBER, LENGTH, YESNO, ...). Sent alongside parameter
 * names so the host can create a parameter that is missing from the shared
 * parameter file with the intended Revit data type instead of plain Text.
 *
 * @generated from message pipeex.revit.v1.ParameterDataTypeHint
 */
export type ParameterDataTypeHint = Message<"pipeex.revit.v1.ParameterDataTypeHint"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string data_type = 2;
   */
  dataType: string;
};

/**
 * Describes the message pipeex.revit.v1.ParameterDataTypeHint.
 * Use `create(ParameterDataTypeHintSchema)` to create a new message.
 */
export const ParameterDataTypeHintSchema: GenMessage<ParameterDataTypeHint> = /*@__PURE__*/
  messageDesc(file_revit_service, 18);

/**
 * @generated from message pipeex.revit.v1.GetOperationProgressRequest
 */
export type GetOperationProgressRequest = Message<"pipeex.revit.v1.GetOperationProgressRequest"> & {
  /**
   * @generated from field: string operation_id = 1;
   */
  operationId: string;
};

/**
 * Describes the message pipeex.revit.v1.GetOperationProgressRequest.
 * Use `create(GetOperationProgressRequestSchema)` to create a new message.
 */
export const GetOperationProgressRequestSchema: GenMessage<GetOperationProgressRequest> = /*@__PURE__*/
  messageDesc(file_revit_service, 19);

/**
 * @generated from message pipeex.revit.v1.OperationProgressItemSnapshot
 */
export type OperationProgressItemSnapshot = Message<"pipeex.revit.v1.OperationProgressItemSnapshot"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string detail = 3;
   */
  detail: string;

  /**
   * @generated from field: pipeex.revit.v1.OperationProgressItemState state = 4;
   */
  state: OperationProgressItemState;

  /**
   * @generated from field: string error = 5;
   */
  error: string;

  /**
   * @generated from field: int32 sequence = 6;
   */
  sequence: number;
};

/**
 * Describes the message pipeex.revit.v1.OperationProgressItemSnapshot.
 * Use `create(OperationProgressItemSnapshotSchema)` to create a new message.
 */
export const OperationProgressItemSnapshotSchema: GenMessage<OperationProgressItemSnapshot> = /*@__PURE__*/
  messageDesc(file_revit_service, 20);

/**
 * @generated from message pipeex.revit.v1.OperationProgressSnapshot
 */
export type OperationProgressSnapshot = Message<"pipeex.revit.v1.OperationProgressSnapshot"> & {
  /**
   * @generated from field: string operation_id = 1;
   */
  operationId: string;

  /**
   * @generated from field: string operation_type = 2;
   */
  operationType: string;

  /**
   * @generated from field: string phase = 3;
   */
  phase: string;

  /**
   * @generated from field: string function_name = 4;
   */
  functionName: string;

  /**
   * @generated from field: string message = 5;
   */
  message: string;

  /**
   * @generated from field: string detail = 6;
   */
  detail: string;

  /**
   * @generated from field: string current_item = 7;
   */
  currentItem: string;

  /**
   * @generated from field: int32 processed = 8;
   */
  processed: number;

  /**
   * @generated from field: int32 total = 9;
   */
  total: number;

  /**
   * @generated from field: int32 percent = 10;
   */
  percent: number;

  /**
   * @generated from field: int64 elapsed_ms = 11;
   */
  elapsedMs: bigint;

  /**
   * @generated from field: int64 eta_ms = 12;
   */
  etaMs: bigint;

  /**
   * @generated from field: string cache_status = 13;
   */
  cacheStatus: string;

  /**
   * @generated from field: int32 issues_found = 14;
   */
  issuesFound: number;

  /**
   * @generated from field: bool result_ready = 15;
   */
  resultReady: boolean;

  /**
   * @generated from field: bool failed = 16;
   */
  failed: boolean;

  /**
   * @generated from field: string error = 17;
   */
  error: string;

  /**
   * @generated from field: pipeex.revit.v1.OperationLifecycleState state = 18;
   */
  state: OperationLifecycleState;

  /**
   * @generated from field: string wait_reason = 19;
   */
  waitReason: string;

  /**
   * @generated from field: int64 wait_elapsed_ms = 20;
   */
  waitElapsedMs: bigint;

  /**
   * @generated from field: int64 active_elapsed_ms = 21;
   */
  activeElapsedMs: bigint;

  /**
   * @generated from field: repeated pipeex.revit.v1.OperationProgressItemSnapshot items = 22;
   */
  items: OperationProgressItemSnapshot[];
};

/**
 * Describes the message pipeex.revit.v1.OperationProgressSnapshot.
 * Use `create(OperationProgressSnapshotSchema)` to create a new message.
 */
export const OperationProgressSnapshotSchema: GenMessage<OperationProgressSnapshot> = /*@__PURE__*/
  messageDesc(file_revit_service, 21);

/**
 * @generated from message pipeex.revit.v1.GetOperationProgressResponse
 */
export type GetOperationProgressResponse = Message<"pipeex.revit.v1.GetOperationProgressResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: pipeex.revit.v1.OperationProgressSnapshot progress = 3;
   */
  progress?: OperationProgressSnapshot | undefined;
};

/**
 * Describes the message pipeex.revit.v1.GetOperationProgressResponse.
 * Use `create(GetOperationProgressResponseSchema)` to create a new message.
 */
export const GetOperationProgressResponseSchema: GenMessage<GetOperationProgressResponse> = /*@__PURE__*/
  messageDesc(file_revit_service, 22);

/**
 * @generated from message pipeex.revit.v1.GetOperationResultRequest
 */
export type GetOperationResultRequest = Message<"pipeex.revit.v1.GetOperationResultRequest"> & {
  /**
   * @generated from field: string operation_id = 1;
   */
  operationId: string;
};

/**
 * Describes the message pipeex.revit.v1.GetOperationResultRequest.
 * Use `create(GetOperationResultRequestSchema)` to create a new message.
 */
export const GetOperationResultRequestSchema: GenMessage<GetOperationResultRequest> = /*@__PURE__*/
  messageDesc(file_revit_service, 23);

/**
 * @generated from message pipeex.revit.v1.GetOperationResultResponse
 */
export type GetOperationResultResponse = Message<"pipeex.revit.v1.GetOperationResultResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: bool result_ready = 3;
   */
  resultReady: boolean;

  /**
   * @generated from field: string result_json = 4;
   */
  resultJson: string;
};

/**
 * Describes the message pipeex.revit.v1.GetOperationResultResponse.
 * Use `create(GetOperationResultResponseSchema)` to create a new message.
 */
export const GetOperationResultResponseSchema: GenMessage<GetOperationResultResponse> = /*@__PURE__*/
  messageDesc(file_revit_service, 24);

/**
 * @generated from message pipeex.revit.v1.GetActiveModelStatusRequest
 */
export type GetActiveModelStatusRequest = Message<"pipeex.revit.v1.GetActiveModelStatusRequest"> & {
};

/**
 * Describes the message pipeex.revit.v1.GetActiveModelStatusRequest.
 * Use `create(GetActiveModelStatusRequestSchema)` to create a new message.
 */
export const GetActiveModelStatusRequestSchema: GenMessage<GetActiveModelStatusRequest> = /*@__PURE__*/
  messageDesc(file_revit_service, 25);

/**
 * @generated from message pipeex.revit.v1.GetActiveModelStatusResponse
 */
export type GetActiveModelStatusResponse = Message<"pipeex.revit.v1.GetActiveModelStatusResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * false when no document is open in the running Revit session.
   *
   * @generated from field: bool has_active_document = 3;
   */
  hasActiveDocument: boolean;

  /**
   * Title of the active document (file name without extension).
   *
   * @generated from field: string document_title = 4;
   */
  documentTitle: string;

  /**
   * Document.IsReadOnly — Revit document opened without write rights
   * (workshared without checkout, opened-as-viewer, etc.).
   *
   * @generated from field: bool is_read_only = 5;
   */
  isReadOnly: boolean;

  /**
   * Document.IsReadOnlyFile — the underlying .rvt file has the OS
   * read-only attribute set. Autodesk sample files (e.g. "Snowdon
   * Towers Sample") ship this way; opening them succeeds but Save will
   * fail. This is a real blocker for parameter writes — UI must treat
   * it the same as is_read_only.
   *
   * @generated from field: bool is_read_only_file = 6;
   */
  isReadOnlyFile: boolean;

  /**
   * Document.IsModifiable — false means a write transaction can't be
   * started right now. Additional safety net on top of the two flags
   * above; UI treats false as a blocker.
   *
   * @generated from field: bool is_modifiable = 7;
   */
  isModifiable: boolean;

  /**
   * Document.IsWorkshared — informational; not a blocker on its own.
   *
   * @generated from field: bool is_workshared = 8;
   */
  isWorkshared: boolean;

  /**
   * Document.IsDetached — workshared file opened "Detached from
   * central". Save won't propagate; warn but don't block.
   *
   * @generated from field: bool is_detached = 9;
   */
  isDetached: boolean;

  /**
   * Document.IsModified — there are unsaved in-memory changes.
   *
   * @generated from field: bool is_modified = 10;
   */
  isModified: boolean;

  /**
   * For workshared documents — user-visible path of the central model
   * (via ModelPathUtils.ConvertModelPathToUserVisiblePath). Empty for
   * non-workshared documents.
   *
   * @generated from field: string central_model_path = 11;
   */
  centralModelPath: string;

  /**
   * True when central_model_path points at an existing file on disk
   * (or its split-file twin). False is a real problem — central
   * disappeared, sync is broken.
   *
   * @generated from field: bool central_model_exists = 12;
   */
  centralModelExists: boolean;
};

/**
 * Describes the message pipeex.revit.v1.GetActiveModelStatusResponse.
 * Use `create(GetActiveModelStatusResponseSchema)` to create a new message.
 */
export const GetActiveModelStatusResponseSchema: GenMessage<GetActiveModelStatusResponse> = /*@__PURE__*/
  messageDesc(file_revit_service, 26);

/**
 * @generated from message pipeex.revit.v1.GetProjectPhasesRequest
 */
export type GetProjectPhasesRequest = Message<"pipeex.revit.v1.GetProjectPhasesRequest"> & {
};

/**
 * Describes the message pipeex.revit.v1.GetProjectPhasesRequest.
 * Use `create(GetProjectPhasesRequestSchema)` to create a new message.
 */
export const GetProjectPhasesRequestSchema: GenMessage<GetProjectPhasesRequest> = /*@__PURE__*/
  messageDesc(file_revit_service, 27);

/**
 * @generated from message pipeex.revit.v1.GetProjectPhasesResponse
 */
export type GetProjectPhasesResponse = Message<"pipeex.revit.v1.GetProjectPhasesResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: repeated string phase_names = 3;
   */
  phaseNames: string[];
};

/**
 * Describes the message pipeex.revit.v1.GetProjectPhasesResponse.
 * Use `create(GetProjectPhasesResponseSchema)` to create a new message.
 */
export const GetProjectPhasesResponseSchema: GenMessage<GetProjectPhasesResponse> = /*@__PURE__*/
  messageDesc(file_revit_service, 28);

/**
 * @generated from message pipeex.revit.v1.GetRecorderContextRequest
 */
export type GetRecorderContextRequest = Message<"pipeex.revit.v1.GetRecorderContextRequest"> & {
};

/**
 * Describes the message pipeex.revit.v1.GetRecorderContextRequest.
 * Use `create(GetRecorderContextRequestSchema)` to create a new message.
 */
export const GetRecorderContextRequestSchema: GenMessage<GetRecorderContextRequest> = /*@__PURE__*/
  messageDesc(file_revit_service, 29);

/**
 * @generated from message pipeex.revit.v1.GetRecorderContextResponse
 */
export type GetRecorderContextResponse = Message<"pipeex.revit.v1.GetRecorderContextResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * false when no document is open in the running Revit session.
   *
   * @generated from field: bool has_active_document = 3;
   */
  hasActiveDocument: boolean;

  /**
   * @generated from field: pipeex.revit.v1.RecorderDocumentInfo document = 4;
   */
  document?: RecorderDocumentInfo | undefined;

  /**
   * @generated from field: pipeex.revit.v1.RecorderViewInfo active_view = 5;
   */
  activeView?: RecorderViewInfo | undefined;

  /**
   * @generated from field: repeated pipeex.revit.v1.RecorderSelectionEntry selection = 6;
   */
  selection: RecorderSelectionEntry[];
};

/**
 * Describes the message pipeex.revit.v1.GetRecorderContextResponse.
 * Use `create(GetRecorderContextResponseSchema)` to create a new message.
 */
export const GetRecorderContextResponseSchema: GenMessage<GetRecorderContextResponse> = /*@__PURE__*/
  messageDesc(file_revit_service, 30);

/**
 * @generated from message pipeex.revit.v1.RecorderDocumentInfo
 */
export type RecorderDocumentInfo = Message<"pipeex.revit.v1.RecorderDocumentInfo"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * Full path; may be redacted before persisting.
   *
   * @generated from field: string path_name = 2;
   */
  pathName: string;

  /**
   * @generated from field: string revit_version = 3;
   */
  revitVersion: string;

  /**
   * Document GUID when available (e.g. worksharing central GUID).
   *
   * @generated from field: string document_guid = 4;
   */
  documentGuid: string;

  /**
   * @generated from field: string active_workset = 5;
   */
  activeWorkset: string;

  /**
   * Best-effort description of the project's length units.
   *
   * @generated from field: string project_units = 6;
   */
  projectUnits: string;

  /**
   * @generated from field: pipeex.revit.v1.RecorderProjectInfo project_information = 7;
   */
  projectInformation?: RecorderProjectInfo | undefined;

  /**
   * @generated from field: repeated pipeex.revit.v1.RecorderLinkedModel linked_models = 8;
   */
  linkedModels: RecorderLinkedModel[];

  /**
   * @generated from field: pipeex.revit.v1.RecorderWorksharingInfo worksharing = 9;
   */
  worksharing?: RecorderWorksharingInfo | undefined;
};

/**
 * Describes the message pipeex.revit.v1.RecorderDocumentInfo.
 * Use `create(RecorderDocumentInfoSchema)` to create a new message.
 */
export const RecorderDocumentInfoSchema: GenMessage<RecorderDocumentInfo> = /*@__PURE__*/
  messageDesc(file_revit_service, 31);

/**
 * @generated from message pipeex.revit.v1.RecorderViewInfo
 */
export type RecorderViewInfo = Message<"pipeex.revit.v1.RecorderViewInfo"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string view_type = 2;
   */
  viewType: string;

  /**
   * @generated from field: int64 view_id = 3;
   */
  viewId: bigint;
};

/**
 * Describes the message pipeex.revit.v1.RecorderViewInfo.
 * Use `create(RecorderViewInfoSchema)` to create a new message.
 */
export const RecorderViewInfoSchema: GenMessage<RecorderViewInfo> = /*@__PURE__*/
  messageDesc(file_revit_service, 32);

/**
 * @generated from message pipeex.revit.v1.RecorderProjectInfo
 */
export type RecorderProjectInfo = Message<"pipeex.revit.v1.RecorderProjectInfo"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string number = 2;
   */
  number: string;

  /**
   * @generated from field: string building_name = 3;
   */
  buildingName: string;

  /**
   * @generated from field: string organization_name = 4;
   */
  organizationName: string;

  /**
   * @generated from field: string client_name = 5;
   */
  clientName: string;
};

/**
 * Describes the message pipeex.revit.v1.RecorderProjectInfo.
 * Use `create(RecorderProjectInfoSchema)` to create a new message.
 */
export const RecorderProjectInfoSchema: GenMessage<RecorderProjectInfo> = /*@__PURE__*/
  messageDesc(file_revit_service, 33);

/**
 * @generated from message pipeex.revit.v1.RecorderLinkedModel
 */
export type RecorderLinkedModel = Message<"pipeex.revit.v1.RecorderLinkedModel"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string path = 2;
   */
  path: string;

  /**
   * @generated from field: bool is_loaded = 3;
   */
  isLoaded: boolean;
};

/**
 * Describes the message pipeex.revit.v1.RecorderLinkedModel.
 * Use `create(RecorderLinkedModelSchema)` to create a new message.
 */
export const RecorderLinkedModelSchema: GenMessage<RecorderLinkedModel> = /*@__PURE__*/
  messageDesc(file_revit_service, 34);

/**
 * @generated from message pipeex.revit.v1.RecorderWorksharingInfo
 */
export type RecorderWorksharingInfo = Message<"pipeex.revit.v1.RecorderWorksharingInfo"> & {
  /**
   * @generated from field: bool is_workshared = 1;
   */
  isWorkshared: boolean;

  /**
   * @generated from field: bool is_detached = 2;
   */
  isDetached: boolean;

  /**
   * @generated from field: string central_model_path = 3;
   */
  centralModelPath: string;

  /**
   * @generated from field: string username = 4;
   */
  username: string;
};

/**
 * Describes the message pipeex.revit.v1.RecorderWorksharingInfo.
 * Use `create(RecorderWorksharingInfoSchema)` to create a new message.
 */
export const RecorderWorksharingInfoSchema: GenMessage<RecorderWorksharingInfo> = /*@__PURE__*/
  messageDesc(file_revit_service, 35);

/**
 * @generated from message pipeex.revit.v1.RecorderSelectionEntry
 */
export type RecorderSelectionEntry = Message<"pipeex.revit.v1.RecorderSelectionEntry"> & {
  /**
   * Revit UniqueId — the primary, stable element key.
   *
   * @generated from field: string unique_id = 1;
   */
  uniqueId: string;

  /**
   * Revit ElementId integer. Session-local; never the primary key.
   *
   * @generated from field: int64 element_id = 2;
   */
  elementId: bigint;

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * Selection source when derivable: unknown | user-in-revit | via-web | command | filter.
   *
   * @generated from field: string source = 4;
   */
  source: string;
};

/**
 * Describes the message pipeex.revit.v1.RecorderSelectionEntry.
 * Use `create(RecorderSelectionEntrySchema)` to create a new message.
 */
export const RecorderSelectionEntrySchema: GenMessage<RecorderSelectionEntry> = /*@__PURE__*/
  messageDesc(file_revit_service, 36);

/**
 * @generated from message pipeex.revit.v1.GetElementSnapshotsRequest
 */
export type GetElementSnapshotsRequest = Message<"pipeex.revit.v1.GetElementSnapshotsRequest"> & {
  /**
   * @generated from field: repeated string unique_ids = 1;
   */
  uniqueIds: string[];
};

/**
 * Describes the message pipeex.revit.v1.GetElementSnapshotsRequest.
 * Use `create(GetElementSnapshotsRequestSchema)` to create a new message.
 */
export const GetElementSnapshotsRequestSchema: GenMessage<GetElementSnapshotsRequest> = /*@__PURE__*/
  messageDesc(file_revit_service, 37);

/**
 * @generated from message pipeex.revit.v1.GetElementSnapshotsResponse
 */
export type GetElementSnapshotsResponse = Message<"pipeex.revit.v1.GetElementSnapshotsResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: repeated pipeex.revit.v1.ElementSnapshot elements = 3;
   */
  elements: ElementSnapshot[];
};

/**
 * Describes the message pipeex.revit.v1.GetElementSnapshotsResponse.
 * Use `create(GetElementSnapshotsResponseSchema)` to create a new message.
 */
export const GetElementSnapshotsResponseSchema: GenMessage<GetElementSnapshotsResponse> = /*@__PURE__*/
  messageDesc(file_revit_service, 38);

/**
 * @generated from message pipeex.revit.v1.ElementSnapshot
 */
export type ElementSnapshot = Message<"pipeex.revit.v1.ElementSnapshot"> & {
  /**
   * @generated from field: string unique_id = 1;
   */
  uniqueId: string;

  /**
   * @generated from field: int64 element_id = 2;
   */
  elementId: bigint;

  /**
   * false when the UniqueId did not resolve (deleted / unstable id).
   *
   * @generated from field: bool is_resolved = 3;
   */
  isResolved: boolean;

  /**
   * @generated from field: string warning = 4;
   */
  warning: string;

  /**
   * @generated from field: string category = 5;
   */
  category: string;

  /**
   * @generated from field: string family_name = 6;
   */
  familyName: string;

  /**
   * @generated from field: string type_name = 7;
   */
  typeName: string;

  /**
   * @generated from field: repeated pipeex.revit.v1.ElementParameterValue instance_parameters = 8;
   */
  instanceParameters: ElementParameterValue[];

  /**
   * @generated from field: repeated pipeex.revit.v1.ElementParameterValue type_parameters = 9;
   */
  typeParameters: ElementParameterValue[];

  /**
   * @generated from field: pipeex.revit.v1.ElementBoundingBox bounding_box = 10;
   */
  boundingBox?: ElementBoundingBox | undefined;

  /**
   * @generated from field: pipeex.revit.v1.ElementLocation location = 11;
   */
  location?: ElementLocation | undefined;

  /**
   * @generated from field: string host_unique_id = 12;
   */
  hostUniqueId: string;

  /**
   * @generated from field: string level = 13;
   */
  level: string;

  /**
   * @generated from field: string workset = 14;
   */
  workset: string;

  /**
   * @generated from field: string phase = 15;
   */
  phase: string;

  /**
   * @generated from field: string design_option = 16;
   */
  designOption: string;

  /**
   * @generated from field: repeated pipeex.revit.v1.RelatedElementRef related_elements = 17;
   */
  relatedElements: RelatedElementRef[];
};

/**
 * Describes the message pipeex.revit.v1.ElementSnapshot.
 * Use `create(ElementSnapshotSchema)` to create a new message.
 */
export const ElementSnapshotSchema: GenMessage<ElementSnapshot> = /*@__PURE__*/
  messageDesc(file_revit_service, 39);

/**
 * @generated from message pipeex.revit.v1.ElementParameterValue
 */
export type ElementParameterValue = Message<"pipeex.revit.v1.ElementParameterValue"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;

  /**
   * @generated from field: string storage_type = 3;
   */
  storageType: string;

  /**
   * @generated from field: bool is_shared = 4;
   */
  isShared: boolean;

  /**
   * @generated from field: bool is_read_only = 5;
   */
  isReadOnly: boolean;
};

/**
 * Describes the message pipeex.revit.v1.ElementParameterValue.
 * Use `create(ElementParameterValueSchema)` to create a new message.
 */
export const ElementParameterValueSchema: GenMessage<ElementParameterValue> = /*@__PURE__*/
  messageDesc(file_revit_service, 40);

/**
 * @generated from message pipeex.revit.v1.ElementBoundingBox
 */
export type ElementBoundingBox = Message<"pipeex.revit.v1.ElementBoundingBox"> & {
  /**
   * @generated from field: double min_x = 1;
   */
  minX: number;

  /**
   * @generated from field: double min_y = 2;
   */
  minY: number;

  /**
   * @generated from field: double min_z = 3;
   */
  minZ: number;

  /**
   * @generated from field: double max_x = 4;
   */
  maxX: number;

  /**
   * @generated from field: double max_y = 5;
   */
  maxY: number;

  /**
   * @generated from field: double max_z = 6;
   */
  maxZ: number;
};

/**
 * Describes the message pipeex.revit.v1.ElementBoundingBox.
 * Use `create(ElementBoundingBoxSchema)` to create a new message.
 */
export const ElementBoundingBoxSchema: GenMessage<ElementBoundingBox> = /*@__PURE__*/
  messageDesc(file_revit_service, 41);

/**
 * @generated from message pipeex.revit.v1.ElementLocation
 */
export type ElementLocation = Message<"pipeex.revit.v1.ElementLocation"> & {
  /**
   * point | curve | none
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: double point_x = 2;
   */
  pointX: number;

  /**
   * @generated from field: double point_y = 3;
   */
  pointY: number;

  /**
   * @generated from field: double point_z = 4;
   */
  pointZ: number;

  /**
   * @generated from field: double start_x = 5;
   */
  startX: number;

  /**
   * @generated from field: double start_y = 6;
   */
  startY: number;

  /**
   * @generated from field: double start_z = 7;
   */
  startZ: number;

  /**
   * @generated from field: double end_x = 8;
   */
  endX: number;

  /**
   * @generated from field: double end_y = 9;
   */
  endY: number;

  /**
   * @generated from field: double end_z = 10;
   */
  endZ: number;
};

/**
 * Describes the message pipeex.revit.v1.ElementLocation.
 * Use `create(ElementLocationSchema)` to create a new message.
 */
export const ElementLocationSchema: GenMessage<ElementLocation> = /*@__PURE__*/
  messageDesc(file_revit_service, 42);

/**
 * @generated from message pipeex.revit.v1.RelatedElementRef
 */
export type RelatedElementRef = Message<"pipeex.revit.v1.RelatedElementRef"> & {
  /**
   * @generated from field: string unique_id = 1;
   */
  uniqueId: string;

  /**
   * @generated from field: string relation = 2;
   */
  relation: string;
};

/**
 * Describes the message pipeex.revit.v1.RelatedElementRef.
 * Use `create(RelatedElementRefSchema)` to create a new message.
 */
export const RelatedElementRefSchema: GenMessage<RelatedElementRef> = /*@__PURE__*/
  messageDesc(file_revit_service, 43);

/**
 * @generated from message pipeex.revit.v1.GetRecorderExportRequest
 */
export type GetRecorderExportRequest = Message<"pipeex.revit.v1.GetRecorderExportRequest"> & {
  /**
   * false = privacy/size toggle: do not include a model copy (reference only).
   *
   * @generated from field: bool include_model = 1;
   */
  includeModel: boolean;
};

/**
 * Describes the message pipeex.revit.v1.GetRecorderExportRequest.
 * Use `create(GetRecorderExportRequestSchema)` to create a new message.
 */
export const GetRecorderExportRequestSchema: GenMessage<GetRecorderExportRequest> = /*@__PURE__*/
  messageDesc(file_revit_service, 44);

/**
 * @generated from message pipeex.revit.v1.GetRecorderExportResponse
 */
export type GetRecorderExportResponse = Message<"pipeex.revit.v1.GetRecorderExportResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: string settings_ref = 3;
   */
  settingsRef: string;

  /**
   * @generated from field: string settings_json = 4;
   */
  settingsJson: string;

  /**
   * @generated from field: pipeex.revit.v1.ModelExportInfo model = 5;
   */
  model?: ModelExportInfo | undefined;

  /**
   * Opaque handle to the staged copy on the host; pass to ReadRecorderModelChunk.
   * Empty when no copy was produced (reference-only / exclusion).
   *
   * @generated from field: string staging_token = 6;
   */
  stagingToken: string;
};

/**
 * Describes the message pipeex.revit.v1.GetRecorderExportResponse.
 * Use `create(GetRecorderExportResponseSchema)` to create a new message.
 */
export const GetRecorderExportResponseSchema: GenMessage<GetRecorderExportResponse> = /*@__PURE__*/
  messageDesc(file_revit_service, 45);

/**
 * @generated from message pipeex.revit.v1.ModelExportInfo
 */
export type ModelExportInfo = Message<"pipeex.revit.v1.ModelExportInfo"> & {
  /**
   * copy | reference
   *
   * @generated from field: string mode = 1;
   */
  mode: string;

  /**
   * Structured warning when a requested copy could not be produced.
   *
   * @generated from field: string warning = 2;
   */
  warning: string;

  /**
   * Relative archive ref (model/test-model.rvt) when mode == copy.
   *
   * @generated from field: string archive_ref = 3;
   */
  archiveRef: string;

  /**
   * @generated from field: pipeex.revit.v1.ModelReference reference = 4;
   */
  reference?: ModelReference | undefined;

  /**
   * @generated from field: repeated pipeex.revit.v1.LinkedModelInfo linked_models = 5;
   */
  linkedModels: LinkedModelInfo[];

  /**
   * Size in bytes of the staged host copy (mode == copy); 0 otherwise.
   *
   * @generated from field: int64 size_bytes = 6;
   */
  sizeBytes: bigint;
};

/**
 * Describes the message pipeex.revit.v1.ModelExportInfo.
 * Use `create(ModelExportInfoSchema)` to create a new message.
 */
export const ModelExportInfoSchema: GenMessage<ModelExportInfo> = /*@__PURE__*/
  messageDesc(file_revit_service, 46);

/**
 * @generated from message pipeex.revit.v1.ModelReference
 */
export type ModelReference = Message<"pipeex.revit.v1.ModelReference"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string path_name = 2;
   */
  pathName: string;

  /**
   * @generated from field: string document_guid = 3;
   */
  documentGuid: string;

  /**
   * @generated from field: string revit_version = 4;
   */
  revitVersion: string;
};

/**
 * Describes the message pipeex.revit.v1.ModelReference.
 * Use `create(ModelReferenceSchema)` to create a new message.
 */
export const ModelReferenceSchema: GenMessage<ModelReference> = /*@__PURE__*/
  messageDesc(file_revit_service, 47);

/**
 * @generated from message pipeex.revit.v1.LinkedModelInfo
 */
export type LinkedModelInfo = Message<"pipeex.revit.v1.LinkedModelInfo"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string archive_ref = 2;
   */
  archiveRef: string;

  /**
   * @generated from field: bool is_loaded = 3;
   */
  isLoaded: boolean;

  /**
   * Size in bytes of the staged linked-model copy; 0 when not bundled.
   *
   * @generated from field: int64 size_bytes = 4;
   */
  sizeBytes: bigint;
};

/**
 * Describes the message pipeex.revit.v1.LinkedModelInfo.
 * Use `create(LinkedModelInfoSchema)` to create a new message.
 */
export const LinkedModelInfoSchema: GenMessage<LinkedModelInfo> = /*@__PURE__*/
  messageDesc(file_revit_service, 48);

/**
 * @generated from message pipeex.revit.v1.ReadRecorderModelChunkRequest
 */
export type ReadRecorderModelChunkRequest = Message<"pipeex.revit.v1.ReadRecorderModelChunkRequest"> & {
  /**
   * staging_token returned by GetRecorderExport.
   *
   * @generated from field: string staging_token = 1;
   */
  stagingToken: string;

  /**
   * Relative archive ref to read (model/test-model.rvt or model/linked-models/<name>.rvt).
   *
   * @generated from field: string archive_ref = 2;
   */
  archiveRef: string;

  /**
   * @generated from field: int64 offset = 3;
   */
  offset: bigint;

  /**
   * Requested max bytes; the host clamps to its own chunk cap.
   *
   * @generated from field: int32 max_bytes = 4;
   */
  maxBytes: number;
};

/**
 * Describes the message pipeex.revit.v1.ReadRecorderModelChunkRequest.
 * Use `create(ReadRecorderModelChunkRequestSchema)` to create a new message.
 */
export const ReadRecorderModelChunkRequestSchema: GenMessage<ReadRecorderModelChunkRequest> = /*@__PURE__*/
  messageDesc(file_revit_service, 49);

/**
 * @generated from message pipeex.revit.v1.ReadRecorderModelChunkResponse
 */
export type ReadRecorderModelChunkResponse = Message<"pipeex.revit.v1.ReadRecorderModelChunkResponse"> & {
  /**
   * @generated from field: bool is_success = 1;
   */
  isSuccess: boolean;

  /**
   * @generated from field: string error = 2;
   */
  error: string;

  /**
   * @generated from field: bytes data = 3;
   */
  data: Uint8Array;

  /**
   * @generated from field: bool eof = 4;
   */
  eof: boolean;

  /**
   * @generated from field: int64 total_size = 5;
   */
  totalSize: bigint;
};

/**
 * Describes the message pipeex.revit.v1.ReadRecorderModelChunkResponse.
 * Use `create(ReadRecorderModelChunkResponseSchema)` to create a new message.
 */
export const ReadRecorderModelChunkResponseSchema: GenMessage<ReadRecorderModelChunkResponse> = /*@__PURE__*/
  messageDesc(file_revit_service, 50);

/**
 * @generated from enum pipeex.revit.v1.OperationLifecycleState
 */
export enum OperationLifecycleState {
  /**
   * @generated from enum value: OPERATION_LIFECYCLE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: OPERATION_LIFECYCLE_STATE_QUEUED = 1;
   */
  QUEUED = 1,

  /**
   * @generated from enum value: OPERATION_LIFECYCLE_STATE_WAITING_FOR_REVIT = 2;
   */
  WAITING_FOR_REVIT = 2,

  /**
   * @generated from enum value: OPERATION_LIFECYCLE_STATE_RUNNING = 3;
   */
  RUNNING = 3,

  /**
   * @generated from enum value: OPERATION_LIFECYCLE_STATE_WAITING_FOR_USER_INPUT = 4;
   */
  WAITING_FOR_USER_INPUT = 4,

  /**
   * @generated from enum value: OPERATION_LIFECYCLE_STATE_COMPLETING = 5;
   */
  COMPLETING = 5,

  /**
   * @generated from enum value: OPERATION_LIFECYCLE_STATE_COMPLETED = 6;
   */
  COMPLETED = 6,

  /**
   * @generated from enum value: OPERATION_LIFECYCLE_STATE_FAILED = 7;
   */
  FAILED = 7,
}

/**
 * Describes the enum pipeex.revit.v1.OperationLifecycleState.
 */
export const OperationLifecycleStateSchema: GenEnum<OperationLifecycleState> = /*@__PURE__*/
  enumDesc(file_revit_service, 0);

/**
 * @generated from enum pipeex.revit.v1.OperationProgressItemState
 */
export enum OperationProgressItemState {
  /**
   * @generated from enum value: OPERATION_PROGRESS_ITEM_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: OPERATION_PROGRESS_ITEM_STATE_RUNNING = 1;
   */
  RUNNING = 1,

  /**
   * @generated from enum value: OPERATION_PROGRESS_ITEM_STATE_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * @generated from enum value: OPERATION_PROGRESS_ITEM_STATE_SKIPPED = 3;
   */
  SKIPPED = 3,

  /**
   * @generated from enum value: OPERATION_PROGRESS_ITEM_STATE_CONFLICT = 4;
   */
  CONFLICT = 4,

  /**
   * @generated from enum value: OPERATION_PROGRESS_ITEM_STATE_FAILED = 5;
   */
  FAILED = 5,
}

/**
 * Describes the enum pipeex.revit.v1.OperationProgressItemState.
 */
export const OperationProgressItemStateSchema: GenEnum<OperationProgressItemState> = /*@__PURE__*/
  enumDesc(file_revit_service, 1);

/**
 * Lifecycle and connectivity service for Revit plugin communication.
 * Handles health checks, authentication handshake, and push events from Revit.
 *
 * @generated from service pipeex.revit.v1.RevitService
 */
export const RevitService: GenService<{
  /**
   * Health check — verifies gRPC server is running inside Revit
   *
   * @generated from rpc pipeex.revit.v1.RevitService.Ping
   */
  ping: {
    methodKind: "unary";
    input: typeof PingRequestSchema;
    output: typeof PingResponseSchema;
  },
  /**
   * Authentication handshake — returns machine fingerprint for license validation
   *
   * @generated from rpc pipeex.revit.v1.RevitService.Connect
   */
  connect: {
    methodKind: "unary";
    input: typeof ConnectRequestSchema;
    output: typeof ConnectResponseSchema;
  },
  /**
   * Server-streaming — pushes Revit events (selection changes, etc.) to Angular client
   *
   * @generated from rpc pipeex.revit.v1.RevitService.SubscribeToEvents
   */
  subscribeToEvents: {
    methodKind: "server_streaming";
    input: typeof SubscribeRequestSchema;
    output: typeof RevitEventSchema;
  },
  /**
   * Write log entries from the web UI to the host file system
   *
   * @generated from rpc pipeex.revit.v1.RevitService.WriteLog
   */
  writeLog: {
    methodKind: "unary";
    input: typeof WriteLogRequestSchema;
    output: typeof WriteLogResponseSchema;
  },
  /**
   * Open native folder browser dialog on the Revit host and return selected path
   *
   * @generated from rpc pipeex.revit.v1.RevitService.BrowseForFolder
   */
  browseForFolder: {
    methodKind: "unary";
    input: typeof BrowseFolderRequestSchema;
    output: typeof BrowseFolderResponseSchema;
  },
  /**
   * Read PipeEX setup status stored in the Revit model via Extensible Storage
   *
   * @generated from rpc pipeex.revit.v1.RevitService.GetModelSetupStatus
   */
  getModelSetupStatus: {
    methodKind: "unary";
    input: typeof GetModelSetupStatusRequestSchema;
    output: typeof GetModelSetupStatusResponseSchema;
  },
  /**
   * Persist PipeEX setup status into the Revit model via Extensible Storage
   *
   * @generated from rpc pipeex.revit.v1.RevitService.SaveModelSetupStatus
   */
  saveModelSetupStatus: {
    methodKind: "unary";
    input: typeof SaveModelSetupStatusRequestSchema;
    output: typeof SaveModelSetupStatusResponseSchema;
  },
  /**
   * Show or hide the PipeEX dockable pane. Used by pick-mode export so the
   * user sees the Revit model while picking elements.
   *
   * @generated from rpc pipeex.revit.v1.RevitService.SetPcfWindowVisibility
   */
  setPcfWindowVisibility: {
    methodKind: "unary";
    input: typeof SetPcfWindowVisibilityRequestSchema;
    output: typeof SetPcfWindowVisibilityResponseSchema;
  },
  /**
   * Read live progress for a host operation started by a feature service.
   *
   * @generated from rpc pipeex.revit.v1.RevitService.GetOperationProgress
   */
  getOperationProgress: {
    methodKind: "unary";
    input: typeof GetOperationProgressRequestSchema;
    output: typeof GetOperationProgressResponseSchema;
  },
  /**
   * Read final payload for a completed host operation.
   *
   * @generated from rpc pipeex.revit.v1.RevitService.GetOperationResult
   */
  getOperationResult: {
    methodKind: "unary";
    input: typeof GetOperationResultRequestSchema;
    output: typeof GetOperationResultResponseSchema;
  },
  /**
   * Probe the currently-open Revit document for write-readiness:
   * is it read-only, workshared, detached from central? Used by feature
   * pages (QuickFill, Validation QuickFix) to gate write operations
   * behind a clear blocking notification when the model can't accept
   * parameter writes.
   *
   * @generated from rpc pipeex.revit.v1.RevitService.GetActiveModelStatus
   */
  getActiveModelStatus: {
    methodKind: "unary";
    input: typeof GetActiveModelStatusRequestSchema;
    output: typeof GetActiveModelStatusResponseSchema;
  },
  /**
   * @generated from rpc pipeex.revit.v1.RevitService.GetProjectPhases
   */
  getProjectPhases: {
    methodKind: "unary";
    input: typeof GetProjectPhasesRequestSchema;
    output: typeof GetProjectPhasesResponseSchema;
  },
  /**
   * Test-Records recorder: snapshot the active document, active view and
   * current selection context. Read-only; marshalled to the Revit main thread.
   *
   * @generated from rpc pipeex.revit.v1.RevitService.GetRecorderContext
   */
  getRecorderContext: {
    methodKind: "unary";
    input: typeof GetRecorderContextRequestSchema;
    output: typeof GetRecorderContextResponseSchema;
  },
  /**
   * Test-Records recorder: snapshot elements (by UniqueId) — category/family/
   * type, parameters, bbox, location, host/level/workset/phase/design option.
   *
   * @generated from rpc pipeex.revit.v1.RevitService.GetElementSnapshots
   */
  getElementSnapshots: {
    methodKind: "unary";
    input: typeof GetElementSnapshotsRequestSchema;
    output: typeof GetElementSnapshotsResponseSchema;
  },
  /**
   * Test-Records recorder: export plugin settings + the model copy/reference plan.
   * When include_model is set the active model is staged on disk and the
   * response carries a staging_token + per-file sizes for the chunked transfer.
   *
   * @generated from rpc pipeex.revit.v1.RevitService.GetRecorderExport
   */
  getRecorderExport: {
    methodKind: "unary";
    input: typeof GetRecorderExportRequestSchema;
    output: typeof GetRecorderExportResponseSchema;
  },
  /**
   * Test-Records recorder: read one chunk of a staged model file. A .rvt
   * routinely exceeds the 32 MB unary cap and server-streaming gRPC-web is
   * broken under WebView2, so the web pulls the staged copy in bounded chunks.
   *
   * @generated from rpc pipeex.revit.v1.RevitService.ReadRecorderModelChunk
   */
  readRecorderModelChunk: {
    methodKind: "unary";
    input: typeof ReadRecorderModelChunkRequestSchema;
    output: typeof ReadRecorderModelChunkResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_revit_service, 0);

